import React from 'react';

export default ({ className, ...other }) => (
  <svg
    {...other}
    className={`icon w16 ${className || ''}`}
    viewBox="0 0 15.284 15.283"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group_448" data-name="Group 448" transform="translate(0)">
      <g id="flaticon1567704307-svg" transform="translate(0 0)">
        <path id="Path_1129" data-name="Path 1129" d="M7.642,0a7.642,7.642,0,1,0,7.642,7.642A7.65,7.65,0,0,0,7.642,0Zm0,14.774a7.132,7.132,0,1,1,7.132-7.132A7.14,7.14,0,0,1,7.642,14.774Z" fill="currentColor" />
        <path id="Path_1130" data-name="Path 1130" d="M13.288,6a.273.273,0,0,1,.288.255v5.859H17.9a.257.257,0,1,1,0,.509H13.288A.273.273,0,0,1,13,12.368V6.255A.273.273,0,0,1,13.288,6Z" transform="translate(-5.892 -4.081)" fill="currentColor" />
      </g>
    </g>
  </svg>
);
